import { Directive, ElementRef, HostListener, inject } from '@angular/core';

/**
 * Bloc cliquable qui ne peut pas devenir un `<button>` sans casser sa mise en
 * page (carte, ligne contenant d'autres boutons) : il s'annonce comme bouton au
 * lecteur d'écran, prend le focus et s'active au clavier (Entrée, Espace), comme
 * un vrai bouton (R8, DS-05). Pour un nouveau gabarit, préférer `<button>`.
 * Usage : `<div vwPressable (click)="open()">…</div>`
 */
@Directive({
  selector: '[vwPressable]',
  standalone: true,
  host: { role: 'button', tabindex: '0' },
})
export class PressableDirective {
  private readonly el = inject<ElementRef<HTMLElement>>(ElementRef);

  @HostListener('keydown', ['$event'])
  onKeydown(event: KeyboardEvent): void {
    // Seulement les touches qui visent CE bloc : un bouton qu'il contient garde les siennes.
    if (event.target !== this.el.nativeElement) return;
    if (event.key !== 'Enter' && event.key !== ' ') return;
    event.preventDefault();
    this.el.nativeElement.click();
  }
}
